import { PrimaryButton } from '@pulse-web-ui/button-v2';
import { Input } from '@pulse-web-ui/input';
import { css, media, mixins, styled } from '@pulse-web-ui/theme';

export const CodeContainer = styled.div`
  ${mixins.flex({})};

  ${media.desktop} {
    max-width: 280px;
  }
`;

export const CodeInputWrapper = styled.div`
  width: calc(100% - 56px);
`;

export const OTPContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 56px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
  width: 56px;
`;

export const Button = styled(PrimaryButton)<{
  $error?: boolean;
  disabled: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 12px;
  align-self: stretch;
  border-radius: 0 ${({ theme }) => theme.common.radiusS}
    ${({ theme }) => theme.common.radiusS} 0;

  ${({ $error, theme }) =>
    $error &&
    css`
      background: ${theme.colors.text.error};
    `}
`;

export const OTPInput = styled(Input)`
  min-width: 225px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;
